




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class GrowingNumber extends Vue {
  @Prop({
    default: null,
  })
  public prefix!: string;

  @Prop({
    default: null,
  })
  public suffix!: string;

  @Prop({
    default: 0,
  })
  public value!: number;

  @Prop({
    default: 500,
  })
  public duration!: number;

  public newValue = 0;
  public step = 0;

  public get newValueFormatted(): number {
    return this.newValue;
  }

  public mounted(): void {
    this.growInit();
  }

  public growInit(): void {
    const m = this.value / (this.duration / 25);
    this.grow(m);
  }
  public grow(m: number): boolean {
    const v = Math.ceil(this.newValue + m);
    if (v > this.value) {
      this.newValue = this.value;
      return false;
    }
    this.newValue = v;
    setTimeout(() => {
      this.grow(m);
    }, 25);
    return true;
  }

  @Watch('value')
  public onValueChange(): void {
    this.growInit();
  }
}
